// // import React, { useState } from "react";

// // export default function FeedbackScreen() {

// //   const [rating, setRating] = useState(0);
// //   const [hover, setHover] = useState(0);
// //   const [feedback, setFeedback] = useState("");
// //   const [showPopup, setShowPopup] = useState(false);

// //   const googleReviewUrl =
// //     "https://g.page/r/YOUR_GOOGLE_REVIEW_LINK";

// //   const handleRating = (value) => {
// //     setRating(value);

// //     if (value >= 4) {
// //       setShowPopup(true);
// //     } else {
// //       setShowPopup(false);
// //     }
// //   };

// //   return (
// //     <>
// //       <style>{`

// //         *{
// //           margin:0;
// //           padding:0;
// //           box-sizing:border-box;
// //           font-family:'Poppins',sans-serif;
// //         }

// //         body{
// //           background:#f4f7fb;
// //         }

// //         .feedback-page{
// //           min-height:100vh;
// //           display:flex;
// //           align-items:center;
// //           justify-content:center;
// //           padding:30px;
// //           background:
// //           linear-gradient(135deg,#fff7ed,#fff,#eef4ff);
// //         }

// //         .feedback-card{
// //           width:100%;
// //           max-width:700px;
// //           background:white;
// //           border-radius:35px;
// //           padding:50px;
// //           box-shadow:0 20px 60px rgba(0,0,0,0.08);
// //           position:relative;
// //           overflow:hidden;
// //         }

// //         .feedback-card::before{
// //           content:'';
// //           position:absolute;
// //           width:250px;
// //           height:250px;
// //           background:rgba(255,140,66,0.08);
// //           border-radius:50%;
// //           top:-100px;
// //           right:-80px;
// //         }

// //         .top{
// //           text-align:center;
// //           position:relative;
// //           z-index:2;
// //         }

// //         .logo{
// //           width:100px;
// //           height:100px;
// //           background:#fff4eb;
// //           border-radius:30px;
// //           margin:auto;
// //           display:flex;
// //           align-items:center;
// //           justify-content:center;
// //           font-size:50px;
// //           margin-bottom:25px;
// //         }

// //         .top h1{
// //           font-size:42px;
// //           color:#111827;
// //           margin-bottom:15px;
// //           font-weight:800;
// //         }

// //         .top p{
// //           color:#6b7280;
// //           font-size:17px;
// //           line-height:1.8;
// //           max-width:500px;
// //           margin:auto;
// //         }

// //         /* STARS */

// //         .stars{
// //           display:flex;
// //           justify-content:center;
// //           gap:18px;
// //           margin-top:45px;
// //           flex-wrap:wrap;
// //         }

// //         .star{
// //           font-size:65px;
// //           cursor:pointer;
// //           transition:0.3s;
// //           color:#d1d5db;
// //         }

// //         .star.active{
// //           color:#ffb703;
// //           transform:scale(1.12);
// //         }

// //         .star:hover{
// //           transform:translateY(-8px) scale(1.1);
// //         }

// //         /* LOW FEEDBACK */

// //         .complaint-box{
// //           margin-top:40px;
// //           background:#fff7ed;
// //           border-radius:28px;
// //           padding:35px;
// //           animation:fade 0.4s ease;
// //         }

// //         .complaint-box h3{
// //           font-size:28px;
// //           color:#111827;
// //           margin-bottom:15px;
// //         }

// //         .complaint-box p{
// //           color:#6b7280;
// //           margin-bottom:25px;
// //           line-height:1.7;
// //         }

// //         .complaint-box textarea{
// //           width:100%;
// //           height:170px;
// //           border:none;
// //           background:white;
// //           border-radius:20px;
// //           padding:20px;
// //           resize:none;
// //           font-size:16px;
// //           outline:none;
// //           box-shadow:0 5px 20px rgba(0,0,0,0.05);
// //         }

// //         .submit-btn{
// //           width:100%;
// //           height:65px;
// //           border:none;
// //           border-radius:18px;
// //           margin-top:25px;
// //           background:linear-gradient(135deg,#ff8c42,#ff5e62);
// //           color:white;
// //           font-size:18px;
// //           font-weight:700;
// //           cursor:pointer;
// //           transition:0.3s;
// //         }

// //         .submit-btn:hover{
// //           transform:translateY(-3px);
// //           box-shadow:0 15px 30px rgba(255,94,98,0.3);
// //         }

// //         /* POSITIVE */

// //         .positive-box{
// //           margin-top:40px;
// //           background:
// //           linear-gradient(135deg,#111827,#1f2937);
// //           border-radius:30px;
// //           padding:40px;
// //           color:white;
// //           text-align:center;
// //           animation:fade 0.4s ease;
// //         }

// //         .positive-box h2{
// //           font-size:34px;
// //           margin-bottom:15px;
// //         }

// //         .positive-box p{
// //           color:#d1d5db;
// //           line-height:1.8;
// //           margin-bottom:30px;
// //         }

// //         .google-btn{
// //           display:inline-flex;
// //           align-items:center;
// //           justify-content:center;
// //           gap:12px;
// //           padding:18px 35px;
// //           border-radius:18px;
// //           background:white;
// //           color:#111827;
// //           text-decoration:none;
// //           font-size:18px;
// //           font-weight:700;
// //           transition:0.3s;
// //         }

// //         .google-btn:hover{
// //           transform:translateY(-4px);
// //         }

// //         /* POPUP */

// //         .popup{
// //           position:fixed;
// //           top:30px;
// //           right:30px;
// //           background:white;
// //           border-radius:22px;
// //           padding:25px;
// //           box-shadow:0 15px 40px rgba(0,0,0,0.12);
// //           z-index:999;
// //           width:340px;
// //           animation:slide 0.4s ease;
// //         }

// //         .popup h3{
// //           font-size:24px;
// //           margin-bottom:10px;
// //           color:#111827;
// //         }

// //         .popup p{
// //           color:#6b7280;
// //           line-height:1.7;
// //         }

// //         @keyframes slide{
// //           from{
// //             opacity:0;
// //             transform:translateX(100px);
// //           }
// //           to{
// //             opacity:1;
// //             transform:translateX(0);
// //           }
// //         }

// //         @keyframes fade{
// //           from{
// //             opacity:0;
// //             transform:translateY(20px);
// //           }
// //           to{
// //             opacity:1;
// //             transform:translateY(0);
// //           }
// //         }

// //         @media(max-width:768px){

// //           .feedback-card{
// //             padding:35px 25px;
// //           }

// //           .top h1{
// //             font-size:30px;
// //           }

// //           .star{
// //             font-size:50px;
// //           }

// //           .popup{
// //             width:90%;
// //             right:5%;
// //             top:20px;
// //           }

// //         }

// //       `}</style>

// //       <div className="feedback-page">

// //         {/* POPUP */}

// //         {showPopup && (

// //           <div className="popup">

// //             <h3>
// //               🎉 Thank You!
// //             </h3>

// //             <p>
// //               We are so happy you loved your experience.
// //               Please support us with a Google review.
// //             </p>

// //           </div>

// //         )}

// //         {/* CARD */}

// //         <div className="feedback-card">

// //           <div className="top">

// //             <div className="logo">
// //               ⭐
// //             </div>

// //             <h1>
// //               Share Your Experience
// //             </h1>

// //             <p>
// //               Your feedback helps restaurants improve service,
// //               rewards and customer experience.
// //             </p>

// //           </div>

// //           {/* STARS */}

// //           <div className="stars">

// //             {[1,2,3,4,5].map((star) => (

// //               <span
// //                 key={star}
// //                 className={`star ${
// //                   star <= (hover || rating)
// //                   ? "active"
// //                   : ""
// //                 }`}
// //                 onMouseEnter={() => setHover(star)}
// //                 onMouseLeave={() => setHover(0)}
// //                 onClick={() => handleRating(star)}
// //               >
// //                 ★
// //               </span>

// //             ))}

// //           </div>

// //           {/* NEGATIVE FEEDBACK */}

// //           {rating > 0 && rating <= 3 && (

// //             <div className="complaint-box">

// //               <h3>
// //                 😔 We’re Sorry!
// //               </h3>

// //               <p>
// //                 Please tell us what went wrong with food or service.
// //                 Your feedback will remain private and only visible to owner.
// //               </p>

// //               <textarea
// //                 placeholder="Write your feedback here..."
// //                 value={feedback}
// //                 onChange={(e) =>
// //                   setFeedback(e.target.value)
// //                 }
// //               ></textarea>

// //               <button className="submit-btn">
// //                 Submit Private Feedback
// //               </button>

// //             </div>

// //           )}

// //           {/* POSITIVE */}

// //           {rating >= 4 && (

// //             <div className="positive-box">

// //               <h2>
// //                 ❤️ Thank You So Much!
// //               </h2>

// //               <p>
// //                 Your positive review means a lot to us.
// //                 Please share your experience publicly on Google.
// //               </p>

// //               <a
// //                 href={googleReviewUrl}
// //                 target="_blank"
// //                 rel="noreferrer"
// //                 className="google-btn"
// //               >
// //                 🌍 Write on Google
// //               </a>

// //             </div>

// //           )}

// //         </div>

// //       </div>
// //     </>
// //   );
// // }

// import React, { useState, useEffect } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";

// export default function AddReviewScreen() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();

//   // URL parameters se ids read karein
//   const merchantId = searchParams.get("merchant_id") || "";
//   const customerId = searchParams.get("customer_id") || "";

//   // States Setup
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [feedback, setFeedback] = useState("");
//   const [selectedTags, setSelectedTags] = useState([]);
//   const [googleReviewUrl, setGoogleReviewUrl] = useState("https://google.com");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // Zomato style smart options rating wise
//   const negativeTags = ["Poor Food Quality 🍔", "Slow Service ⏳", "Rude Staff 👥", "Unhygienic 🧼", "Overpriced 💸"];
//   const positiveTags = ["Delicious Food 😋", "Super Fast Service ⚡", "Great Ambience 🎵", "Friendly Staff Handlers 🤝", "Value for Money 💰"];

//   // Page load par us merchant ka google review link fetch karein
//   useEffect(() => {
//     if (merchantId) {
//       const formdata = new FormData();
//       formdata.append("merchant_id", merchantId);

//       fetch("https://countmyvisit.com/Apis/get_google_review.php", {
//         method: "POST",
//         body: formdata
//       })
//         .then((res) => res.text())
//         .then((result) => {
//           let cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData.success && parsedData.data?.google_review_link) {
//             setGoogleReviewUrl(parsedData.data.google_review_link);
//           }
//         })
//         .catch((err) => console.error("Error fetching google review link:", err));
//     }
//   }, [merchantId]);

//   // Handle Dynamic Tags Click
//   const handleTagClick = (tag) => {
//     let updatedTags = [...selectedTags];
//     if (updatedTags.includes(tag)) {
//       updatedTags = updatedTags.filter((t) => t !== tag);
//     } else {
//       updatedTags.push(tag);
//     }
//     setSelectedTags(updatedTags);

//     // Sync input text area with selected tags
//     const tagsString = updatedTags.join(", ");
//     setFeedback(tagsString);
//   };

//   // Submit Feedback API Call
//   const handleSubmitFeedback = (e) => {
//     if (rating === 0) return alert("Please select a star rating first! ⭐️");
    
//     setIsSubmitting(true);

//     const formdata = new FormData();
//     formdata.append("customer_id", customerId);
//     formdata.append("merchant_id", merchantId);
//     formdata.append("review", feedback || `Rated ${rating} Stars`);
//     formdata.append("rating", String(rating)); // API key parameter setup

//     fetch("https://countmyvisit.com/Apis/add_review.php", {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     })
//       .then((response) => response.text())
//       .then((result) => {
//         alert("Feedback Submitted Successfully! 🎉");
        
//         // Agar 4 ya 5 star h toh google window khol do, varna vapis bhej do dashboard pr
//         if (rating >= 4) {
//           window.open(googleReviewUrl, "_blank", "noopener,noreferrer");
//         }
//         navigate(-1); // Back to previous page
//       })
//       .catch((error) => {
//         console.error("Critical submission mismatch error:", error);
//         alert("Something went wrong. Please try again.");
//       })
//       .finally(() => setIsSubmitting(false));
//   };

//   return (
//     <div style={{
//       minHeight: "100vh",
//       background: "#f8fafc",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: "20px",
//       fontFamily: "'Inter', sans-serif"
//     }}>
//       <div style={{
//         background: "#ffffff",
//         maxWidth: "480px",
//         width: "100%",
//         borderRadius: "24px",
//         boxShadow: "0 20px 40px rgba(0,0,0,0.04)",
//         border: "1px solid #e2e8f0",
//         padding: "32px",
//         textAlign: "center"
//       }}>
//         {/* Header Block */}
//         <div style={{ marginBottom: "24px" }}>
//           <div style={{ fontSize: "40px", marginBottom: "12px" }}>🍽️</div>
//           <h2 style={{ fontSize: "24px", fontWeight: "800", color: "#0f172a", margin: "0 0 8px 0" }}>Share Your Experience</h2>
//           <p style={{ fontSize: "14px", color: "#64748b", margin: 0, lineHeight: "1.5" }}>
//             Your transparent feedback helps stores scale rewards and elevate service criteria.
//           </p>
//         </div>

//         {/* Dynamic Star Rating Block */}
//         <div style={{ 
//           display: "flex", 
//           justifyContent: "center", 
//           gap: "12px", 
//           margin: "25px 0",
//           fontSize: "42px"
//         }}>
//           {[1, 2, 3, 4, 5].map((star) => (
//             <span
//               key={star}
//               style={{
//                 cursor: "pointer",
//                 color: star <= (hover || rating) ? "#ffb020" : "#cbd5e1",
//                 transition: "transform 0.1s ease, color 0.1s ease",
//                 transform: star <= hover ? "scale(1.15)" : "scale(1)"
//               }}
//               onMouseEnter={() => setHover(star)}
//               onMouseLeave={() => setHover(0)}
//               onClick={() => {
//                 setRating(star);
//                 setSelectedTags([]); // Rating change hone pr purane tags reset kardo
//               }}
//             >
//               ★
//             </span>
//           ))}
//         </div>

//         {/* Dynamic Context Processing Units */}
//         {rating > 0 && (
//           <div style={{ animation: "fadeIn 0.3s ease", textAlign: "left", marginTop: "20px" }}>
            
//             {/* Quick Option Badges Header */}
//             <label style={{ fontSize: "13px", fontWeight: "700", color: "#475569", display: "block", marginBottom: "10px" }}>
//               {rating <= 3 ? "What went wrong? (Select Options)" : "What did you love most?"}
//             </label>

//             {/* Badges Layout Grid Wrapper */}
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "18px" }}>
//               {(rating <= 3 ? negativeTags : positiveTags).map((tag) => {
//                 const isSelected = selectedTags.includes(tag);
//                 return (
//                   <span
//                     key={tag}
//                     onClick={() => handleTagClick(tag)}
//                     style={{
//                       padding: "8px 14px",
//                       borderRadius: "100px",
//                       fontSize: "12px",
//                       fontWeight: "600",
//                       cursor: "pointer",
//                       border: isSelected ? "1px solid transparent" : "1px solid #e2e8f0",
//                       backgroundColor: isSelected ? (rating <= 3 ? "#fee2e2" : "#dcfce7") : "#ffffff",
//                       color: isSelected ? (rating <= 3 ? "#991b1b" : "#166534") : "#64748b",
//                       transition: "all 0.15s ease"
//                     }}
//                   >
//                     {tag}
//                   </span>
//                 );
//               })}
//             </div>

//             {/* Detailed Text Input */}
//             <label style={{ fontSize: "13px", fontWeight: "700", color: "#475569", display: "block", marginBottom: "8px" }}>
//               Additional Comments (Optional)
//             </label>
//             <textarea
//               style={{
//                 width: "100%",
//                 height: "90px",
//                 padding: "12px",
//                 borderRadius: "12px",
//                 border: "1px solid #cbd5e1",
//                 fontSize: "14px",
//                 outline: "none",
//                 resize: "none",
//                 fontFamily: "inherit",
//                 boxSizing: "border-box"
//               }}
//               placeholder="Tell us more about your experience..."
//               value={feedback}
//               onChange={(e) => setFeedback(e.target.value)}
//             />

//             {/* Dynamic Interactive Action Buttons */}
//             {rating <= 3 ? (
//               <button
//                 disabled={isSubmitting}
//                 onClick={handleSubmitFeedback}
//                 style={{
//                   width: "100%",
//                   height: "46px",
//                   background: "#1e293b",
//                   color: "#ffffff",
//                   border: "none",
//                   borderRadius: "12px",
//                   fontSize: "14px",
//                   fontWeight: "700",
//                   cursor: "pointer",
//                   marginTop: "16px",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
//                 }}
//               >
//                 {isSubmitting ? "Submitting..." : "Submit Private Feedback"}
//               </button>
//             ) : (
//               <div style={{ marginTop: "16px", background: "#f8fafc", padding: "16px", borderRadius: "16px", border: "1px dashed #2563eb" }}>
//                 <p style={{ fontSize: "13px", color: "#1e3a8a", fontWeight: "600", margin: "0 0 12px 0", textAlign: "center" }}>
//                   🎉 Awesome! Please tap below to also drop this review on Google to help us scale!
//                 </p>
//                 <button
//                   disabled={isSubmitting}
//                   onClick={handleSubmitFeedback}
//                   style={{
//                     width: "100%",
//                     height: "46px",
//                     background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
//                     color: "#ffffff",
//                     border: "none",
//                     borderRadius: "12px",
//                     fontSize: "14px",
//                     fontWeight: "700",
//                     cursor: "pointer",
//                     boxShadow: "0 4px 12px rgba(37,99,235,0.2)"
//                   }}
//                 >
//                   {isSubmitting ? "Syncing..." : "🌍 Submit & Open Google Review"}
//                 </button>
//               </div>
//             )}
//           </div>
//         )}
        
//         {/* Cancel Action Fallback Link */}
//         <button 
//           onClick={() => navigate(-1)} 
//           style={{ 
//             background: "none", 
//             border: "none", 
//             color: "#64748b", 
//             fontSize: "13px", 
//             fontWeight: "600", 
//             marginTop: "20px", 
//             cursor: "pointer", 
//             textDecoration: "underline" 
//           }}
//         >
//           Nevermind, Go Back
//         </button>
//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";

// export default function AddReviewScreen() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();

//   // URL parameters se data extract karein
//   const merchantId = searchParams.get("merchant_id") || "";
//   const customerId = searchParams.get("customer_id") || "";

//   // Functional States
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [feedback, setFeedback] = useState("");
//   const [selectedTags, setSelectedTags] = useState([]);
//   const [googleReviewUrl, setGoogleReviewUrl] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [copiedIndex, setCopiedIndex] = useState(null);

//   // Dynamic Suggestion Badges (Zomato/Swiggy Style)
//   const negativeTags = ["Poor Food Quality 🍔", "Slow Service ⏳", "Rude Staff 👥", "Unhygienic 🧼", "Overpriced 💸"];
//   const positiveTags = ["Delicious Food 😋", "Super Fast Service ⚡", "Great Ambience 🎵", "Friendly Staff 🤝", "Value for Money 💰"];

//   // 📋 Premium Ready-made Review Templates for Google (Copy to Clipboard)
//   const reviewTemplates = [
//     "Amazing experience! The food was absolutely delicious and the service was super fast. Highly recommended! ⭐⭐⭐⭐⭐",
//     "Loved the ambience and hospitality here. A perfect place to hang out with friends and family. Will visit again soon! 🙌",
//     "Top notch quality and very hygienic setup. Completely value for money. 10/10 for the staff behavior! 💎"
//   ];

//   // Component mount hone par aapki provided API structure ke hisab se google link lana
//   useEffect(() => {
//     if (merchantId) {
//       const formdata = new FormData();
//       formdata.append("merchant_id", merchantId);

//       fetch("https://countmyvisit.com/Apis/get_google_review.php", {
//         method: "POST",
//         body: formdata
//       })
//         .then((res) => res.text())
//         .then((result) => {
//           // Aapka response sanitization framework (Removes "DATABASE CONNECTED")
//           let cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//           const parsedData = JSON.parse(cleanJsonString);
          
//           if (parsedData.success && parsedData.data?.google_review_link) {
//             setGoogleReviewUrl(parsedData.data.google_review_link);
//           }
//         })
//         .catch((err) => console.error("Error fetching google review endpoint:", err));
//     }
//   }, [merchantId]);

//   // Handle Tag Selection
//   const handleTagClick = (tag) => {
//     let updatedTags = [...selectedTags];
//     if (updatedTags.includes(tag)) {
//       updatedTags = updatedTags.filter((t) => t !== tag);
//     } else {
//       updatedTags.push(tag);
//     }
//     setSelectedTags(updatedTags);
//     setFeedback(updatedTags.join(", "));
//   };

//   // Copy Template Handler
//   const handleCopyTemplate = (text, index) => {
//     navigator.clipboard.writeText(text);
//     setFeedback(text); // Auto fill in textbox too
//     setCopiedIndex(index);
//     setTimeout(() => setCopiedIndex(null), 2000); // 2 sec notification feedback
//   };

//   // Main Form Submission Router
//   const handleSubmitFeedback = () => {
//     if (rating === 0) {
//       alert("Please select your star rating! ⭐️");
//       return;
//     }

//     setIsSubmitting(true);

//     const formdata = new FormData();
//     formdata.append("customer_id", customerId);
//     formdata.append("merchant_id", merchantId);
//     formdata.append("review", feedback || `Rated ${rating} Stars`);
//     formdata.append("rating", String(rating));

//     fetch("https://countmyvisit.com/Apis/add_review.php", {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     })
//       .then((response) => response.text())
//       .then(() => {
//         alert("Review saved successfully! 🎉");
        
//         // Agar 4 or 5 star h toh direct real google review portal wrapper trigger karo
//         if (rating >= 4 && googleReviewUrl) {
//           window.open(googleReviewUrl, "_blank", "noopener,noreferrer");
//         }
//         navigate(-1);
//       })
//       .catch((error) => {
//         console.error("Submission pipeline collapsed:", error);
//         alert("Something went wrong, please try again.");
//       })
//       .finally(() => setIsSubmitting(false));
//   };

//   return (
//     <div style={{
//       minHeight: "100vh",
//       background: "linear-gradient(145deg, #f8fafc, #f1f5f9)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: "24px",
//       fontFamily: "'Inter', system-ui, sans-serif"
//     }}>
//       <div style={{
//         background: "#ffffff",
//         maxWidth: "500px",
//         width: "100%",
//         borderRadius: "28px",
//         boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.05)",
//         border: "1px solid #e2e8f0",
//         padding: "36px",
//         boxSizing: "border-box"
//       }}>
//         {/* Header Block */}
//         <div style={{ textAlign: "center", marginBottom: "28px" }}>
//           <div style={{ fontSize: "44px", marginBottom: "14px" }}>⭐</div>
//           <h2 style={{ fontSize: "26px", fontWeight: "800", color: "#0f172a", margin: "0 0 6px 0", letterSpacing: "-0.5px" }}>
//             Rate Your Experience
//           </h2>
//           <p style={{ fontSize: "14px", color: "#64748b", margin: 0, lineHeight: "1.6" }}>
//             Your feedback directly impacts the reward ecosystem and service standards.
//           </p>
//         </div>

//         {/* Premium Animated Star Segment */}
//         <div style={{ display: "flex", justifyContent: "center", gap: "14px", margin: "24px 0 30px 0" }}>
//           {[1, 2, 3, 4, 5].map((star) => (
//             <span
//               key={star}
//               style={{
//                 cursor: "pointer",
//                 fontSize: "46px",
//                 color: star <= (hover || rating) ? "#ffb020" : "#cbd5e1",
//                 transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
//                 transform: star <= hover ? "scale(1.2)" : "scale(1)"
//               }}
//               onMouseEnter={() => setHover(star)}
//               onMouseLeave={() => setHover(0)}
//               onClick={() => {
//                 setRating(star);
//                 setSelectedTags([]);
//               }}
//             >
//               ★
//             </span>
//           ))}
//         </div>

//         {/* Conditional Logic UI Blocks */}
//         {rating > 0 && (
//           <div style={{ animation: "fadeIn 0.3s ease" }}>
            
//             {/* Quick Multi-Select Suggestion Badges */}
//             <div style={{ marginBottom: "24px" }}>
//               <label style={{ fontSize: "13px", fontWeight: "700", color: "#334155", display: "block", marginBottom: "12px" }}>
//                 {rating <= 3 ? "What went wrong? (Select multiple)" : "What did you appreciate the most?"}
//               </label>
//               <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
//                 {(rating <= 3 ? negativeTags : positiveTags).map((tag) => {
//                   const isSelected = selectedTags.includes(tag);
//                   return (
//                     <button
//                       key={tag}
//                       type="button"
//                       onClick={() => handleTagClick(tag)}
//                       style={{
//                         padding: "8px 16px",
//                         borderRadius: "100px",
//                         fontSize: "12px",
//                         fontWeight: "600",
//                         cursor: "pointer",
//                         border: isSelected ? "1px solid transparent" : "1px solid #e2e8f0",
//                         backgroundColor: isSelected ? (rating <= 3 ? "#fee2e2" : "#dcfce7") : "#ffffff",
//                         color: isSelected ? (rating <= 3 ? "#991b1b" : "#166534") : "#475569",
//                         boxShadow: isSelected ? "0 2px 4px rgba(0,0,0,0.02)" : "none",
//                         transition: "all 0.1s ease"
//                       }}
//                     >
//                       {tag}
//                     </button>
//                   );
//                 })}
//               </div>
//             </div>

//             {/* 📋 GOOGLE REVIEW TEMPLATES PANEL (VISIBLE ON 4+ STARS) */}
//             {rating >= 4 && (
//               <div style={{ marginBottom: "24px", background: "#f8fafc", padding: "16px", borderRadius: "16px", border: "1px solid #e2e8f0", textAlign: "left" }}>
//                 <label style={{ fontSize: "12px", fontWeight: "800", color: "#1e3a8a", display: "block", marginBottom: "10px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
//                   💡 Express Copy Templates for Google:
//                 </label>
//                 <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//                   {reviewTemplates.map((template, idx) => (
//                     <div 
//                       key={idx}
//                       style={{
//                         background: "#ffffff",
//                         padding: "12px",
//                         borderRadius: "12px",
//                         fontSize: "12px",
//                         color: "#334155",
//                         border: "1px solid #edf2f7",
//                         position: "relative",
//                         lineHeight: "1.5"
//                       }}
//                     >
//                       <div>{template}</div>
//                       <button
//                         type="button"
//                         onClick={() => handleCopyTemplate(template, idx)}
//                         style={{
//                           marginTop: "8px",
//                           background: copiedIndex === idx ? "#22c55e" : "#f1f5f9",
//                           color: copiedIndex === idx ? "#ffffff" : "#475569",
//                           border: "none",
//                           padding: "4px 10px",
//                           borderRadius: "6px",
//                           fontSize: "11px",
//                           fontWeight: "700",
//                           cursor: "pointer",
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: "4px"
//                         }}
//                       >
//                         {copiedIndex === idx ? "📋 Copied & Selected!" : "✨ Copy This Review"}
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {/* Detailed Custom Review Box */}
//             <div style={{ marginBottom: "24px", textAlign: "left" }}>
//               <label style={{ fontSize: "13px", fontWeight: "700", color: "#334155", display: "block", marginBottom: "8px" }}>
//                 Your Review Text
//               </label>
//               <textarea
//                 style={{
//                   width: "100%",
//                   height: "95px",
//                   padding: "14px",
//                   borderRadius: "14px",
//                   border: "1px solid #cbd5e1",
//                   fontSize: "14px",
//                   outline: "none",
//                   resize: "none",
//                   fontFamily: "inherit",
//                   boxSizing: "border-box",
//                   color: "#334155",
//                   lineHeight: "1.5"
//                 }}
//                 placeholder="Share more details about your experience here..."
//                 value={feedback}
//                 onChange={(e) => setFeedback(e.target.value)}
//               />
//             </div>

//             {/* Final Action Buttons Engine */}
//             {rating <= 3 ? (
//               <button
//                 type="button"
//                 disabled={isSubmitting}
//                 onClick={handleSubmitFeedback}
//                 style={{
//                   width: "100%",
//                   height: "48px",
//                   background: "#0f172a",
//                   color: "#ffffff",
//                   border: "none",
//                   borderRadius: "12px",
//                   fontSize: "14px",
//                   fontWeight: "700",
//                   cursor: "pointer",
//                   boxShadow: "0 4px 12px rgba(15,23,42,0.15)",
//                   transition: "opacity 0.2s"
//                 }}
//               >
//                 {isSubmitting ? "Submitting..." : "Submit Private Feedback 🔒"}
//               </button>
//             ) : (
//               <div style={{ background: "#eff6ff", padding: "16px", borderRadius: "18px", border: "1px dashed #3b82f6" }}>
//                 <p style={{ fontSize: "13px", color: "#1e40af", fontWeight: "600", margin: "0 0 12px 0", textAlign: "center", lineHeight: "1.5" }}>
//                   Your text is ready! Tapping below will save points & launch your Google review portal. Just paste there! 🚀
//                 </p>
//                 <button
//                   type="button"
//                   disabled={isSubmitting}
//                   onClick={handleSubmitFeedback}
//                   style={{
//                     width: "100%",
//                     height: "48px",
//                     background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
//                     color: "#ffffff",
//                     border: "none",
//                     borderRadius: "12px",
//                     fontSize: "14px",
//                     fontWeight: "700",
//                     cursor: "pointer",
//                     boxShadow: "0 4px 14px rgba(37,99,235,0.25)"
//                   }}
//                 >
//                   {isSubmitting ? "Syncing Network..." : "🌍 Submit & Open Google Page"}
//                 </button>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Back Navigation Trigger */}
//         <div style={{ marginTop: "24px" }}>
//           <button
//             type="button"
//             onClick={() => navigate(-1)}
//             style={{
//               background: "none",
//               border: "none",
//               color: "#94a3b8",
//               fontSize: "13px",
//               fontWeight: "600",
//               cursor: "pointer",
//               textDecoration: "underline"
//             }}
//           >
//             Go Back To Dashboard
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function AddReviewScreen() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // URL parameters se data nikalna
  const merchantId = searchParams.get("merchant_id") || "";
  const customerId = searchParams.get("customer_id") || "";

  // Core Functional States
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [googleReviewUrl, setGoogleReviewUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);

  // Quick Tags (Click karte hi text area me append honge)
  const negativeTags = ["Slow Service ⏳", "Cold Food 🍔", "Rude Staff 👥", "Unhygienic 🧼", "Overpriced 💸"];
  const positiveTags = ["Delicious Food 😋", "Fast Service ⚡", "Great Ambience 🎵", "Friendly Staff 🤝", "Value for Money 💰"];

  // 📋 Direct Copy Templates for Google Review
  const reviewTemplates = [
    "Amazing experience! The food was absolutely delicious and the service was super fast. Highly recommended! ⭐⭐⭐⭐⭐",
    "Loved the ambience and hospitality here. A perfect place to hang out. Will visit again soon! 🙌",
    "Top notch quality and very hygienic setup. 10/10 for the staff behavior! 💎"
  ];

  // Fetch Google Link on Mount
  useEffect(() => {
    if (merchantId) {
      const formdata = new FormData();
      formdata.append("merchant_id", merchantId);

      fetch("https://countmyvisit.com/Apis/get_google_review.php", {
        method: "POST",
        body: formdata
      })
        .then((res) => res.text())
        .then((result) => {
          let cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
          const parsedData = JSON.parse(cleanJsonString);
          if (parsedData.success && parsedData.data?.google_review_link) {
            setGoogleReviewUrl(parsedData.data.google_review_link);
          }
        })
        .catch((err) => console.error("Error fetching google review link:", err));
    }
  }, [merchantId]);

  // Handle Tag Selection
  const handleTagClick = (tag) => {
    let updatedTags = [...selectedTags];
    if (updatedTags.includes(tag)) {
      updatedTags = updatedTags.filter((t) => t !== tag);
    } else {
      updatedTags.push(tag);
    }
    setSelectedTags(updatedTags);
    setFeedback(updatedTags.join(", "));
  };

  // Copy Template Handler
  const handleCopyTemplate = (text, index) => {
    navigator.clipboard.writeText(text);
    setFeedback(text); // Auto fill in text box too
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };

  // Main Submit & Instant Redirect Handler
  const handleSubmitFeedback = () => {
    if (rating === 0) return alert("Please select a star rating first! ⭐️");

    setIsSubmitting(true);

    const formdata = new FormData();
    formdata.append("customer_id", customerId);
    formdata.append("merchant_id", merchantId);
    formdata.append("review", feedback || `Rated ${rating} Stars`);
    formdata.append("rating", String(rating));

    fetch("https://countmyvisit.com/Apis/add_review.php", {
      method: "POST",
      body: formdata,
      redirect: "follow"
    })
      .then((response) => response.text())
      .then(() => {
        // AGAR 4 YA 5 STAR HAI -> BINA PUCHE INSTANT GOOGLE REDIRECT
        if (rating >= 4 && googleReviewUrl) {
          window.location.href = googleReviewUrl; // Kisi click ya popup ka wait nahi, seedhe redirect!
        } else {
          alert("Thank you for your private feedback! 🙏");
          navigate(-1);
        }
      })
      .catch((error) => {
        console.error("API error:", error);
        alert("Something went wrong, please try again.");
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f8fafc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
      fontFamily: "'Inter', sans-serif"
    }}>
      <div style={{
        background: "#ffffff",
        maxWidth: "460px",
        width: "100%",
        borderRadius: "24px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
        border: "1px solid #e2e8f0",
        padding: "32px",
        boxSizing: "border-box",
        textAlign: "center"
      }}>
        
        {/* Header */}
        <div style={{ marginBottom: "24px" }}>
          <div style={{ fontSize: "40px", marginBottom: "8px" }}>⭐</div>
          <h2 style={{ fontSize: "24px", fontWeight: "800", color: "#0f172a", margin: "0 0 6px 0" }}>
            Share Your Experience
          </h2>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0, lineHeight: "1.5" }}>
            Your rating keeps us going. Select stars to begin.
          </p>
        </div>

        {/* Big Premium Stars */}
        <div style={{ display: "flex", justifyContent: "center", gap: "12px", margin: "20px 0" }}>
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              style={{
                cursor: "pointer",
                fontSize: "44px",
                color: star <= (hover || rating) ? "#ffb020" : "#cbd5e1",
                transition: "transform 0.1s ease"
              }}
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(0)}
              onClick={() => {
                setRating(star);
                setSelectedTags([]);
              }}
            >
              ★
            </span>
          ))}
        </div>

        {/* Dynamic Content */}
        {rating > 0 && (
          <div style={{ textAlign: "left", marginTop: "20px" }}>
            
            {/* Suggestion Badges */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{ fontSize: "13px", fontWeight: "700", color: "#475569", display: "block", marginBottom: "10px" }}>
                {rating <= 3 ? "What went wrong?" : "What did you love the most?"}
              </label>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {(rating <= 3 ? negativeTags : positiveTags).map((tag) => {
                  const isSelected = selectedTags.includes(tag);
                  return (
                    <span
                      key={tag}
                      onClick={() => handleTagClick(tag)}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "100px",
                        fontSize: "12px",
                        fontWeight: "600",
                        cursor: "pointer",
                        border: isSelected ? "1px solid transparent" : "1px solid #e2e8f0",
                        backgroundColor: isSelected ? (rating <= 3 ? "#fee2e2" : "#dcfce7") : "#ffffff",
                        color: isSelected ? (rating <= 3 ? "#991b1b" : "#166534") : "#475569"
                      }}
                    >
                      {tag}
                    </span>
                  );
                })}
              </div>
            </div>

            {/* Google Review Express Copy Templates (Only for 4 & 5 Stars) */}
            {rating >= 4 && (
              <div style={{ marginBottom: "20px", background: "#f8fafc", padding: "14px", borderRadius: "16px", border: "1px solid #e2e8f0" }}>
                <label style={{ fontSize: "12px", fontWeight: "800", color: "#2563eb", display: "block", marginBottom: "8px" }}>
                  📋 Click to Copy & Auto-Fill Review:
                </label>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  {reviewTemplates.map((template, idx) => (
                    <div 
                      key={idx}
                      style={{
                        background: "#ffffff",
                        padding: "10px",
                        borderRadius: "10px",
                        fontSize: "12px",
                        color: "#334155",
                        border: "1px solid #edf2f7"
                      }}
                    >
                      <div style={{ marginBottom: "6px" }}>{template}</div>
                      <button
                        type="button"
                        onClick={() => handleCopyTemplate(template, idx)}
                        style={{
                          background: copiedIndex === idx ? "#22c55e" : "#e2e8f0",
                          color: copiedIndex === idx ? "#ffffff" : "#475569",
                          border: "none",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          fontSize: "11px",
                          fontWeight: "700",
                          cursor: "pointer"
                        }}
                      >
                        {copiedIndex === idx ? "✓ Copied!" : "✨ Copy Text"}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Final Text Area */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{ fontSize: "13px", fontWeight: "700", color: "#475569", display: "block", marginBottom: "6px" }}>
                Write your comments below
              </label>
              <textarea
                style={{
                  width: "100%",
                  height: "80px",
                  padding: "12px",
                  borderRadius: "12px",
                  border: "1px solid #cbd5e1",
                  fontSize: "14px",
                  outline: "none",
                  resize: "none",
                  boxSizing: "border-box"
                }}
                placeholder="Write or select from templates above..."
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
            </div>

            {/* Direct Submission Button Engine */}
            <button
              type="button"
              disabled={isSubmitting}
              onClick={handleSubmitFeedback}
              style={{
                width: "100%",
                height: "48px",
                background: rating <= 3 ? "#1e293b" : "linear-gradient(135deg, #2563eb, #1d4ed8)",
                color: "#ffffff",
                border: "none",
                borderRadius: "12px",
                fontSize: "14px",
                fontWeight: "700",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(37,99,235,0.15)"
              }}
            >
              {isSubmitting 
                ? "Processing..." 
                : rating <= 3 
                  ? "Submit Private Feedback 🔒" 
                  : "Submit & Redirect to Google 🚀"
              }
            </button>
          </div>
        )}
      </div>
    </div>
  );
}